var map = {
	"./workcase3Other1.jpg": 8518,
	"./workcase3Other2.jpg": 4305,
	"./workcase3Other3.jpg": 708,
	"./workcase3Other4.jpg": 7087,
	"./workcase3Other5.jpg": 706,
	"./workcase3Other6.jpg": 4861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7016;